<p-toast (onClose)="closed($event)" class="custom-toast"></p-toast>
